<template>
    <v-container class="white">
        <v-row>
            <v-col cols="12">
                <v-btn-toggle v-show="false" v-model="filtroPorTurma" mandatory @change="onFilterChange">
                    <v-btn :value="false">
                        <v-icon>mdi-calendar</v-icon>
                        Por Ano Letivo
                    </v-btn>
                    <!-- <v-btn :value="true">
                        <v-icon>mdi-school</v-icon>
                        Por Turma
                    </v-btn> -->
                </v-btn-toggle>

                <v-row class="mt-4">
                    <!-- Ano Letivo SEMPRE VISÍVEL -->
                    <v-col cols="12" md="2">
                        <v-select v-model="anolectivoSelected" :items="listarAnosLectivo" @change="onAnolectivoChange"
                            label="Selecione o Ano Lectivo" item-value="descricao" item-text="novadescricao">
                        </v-select>
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-select v-model="tipoNotaSelected" :rules="ruleRequired" :items="tiposDeNota"
                            item-value="idTipoNota" required item-text="descricao" label="Selecione o Tipo de Nota"
                            return-object :item-disabled="item => !item.show"></v-select>
                    </v-col>

                    <v-col cols="12" md="3">
                        <v-select v-model="filtroIsNotaLancadaSelecionado" :items="filtroIsNotaLancada"
                            :rules="ruleRequired" item-text="descricao" item-value="isNotaLancada"
                            label="Filtrar professores por status de lançamento de notas" return-object />
                    </v-col>

                    <!-- Os campos abaixo só aparecem se filtroPorTurma for true -->
                    <v-col v-if="filtroPorTurma" cols="12" md="3">
                        <v-combobox :items="cursos" item-text="descricao" @change="onCursoChange" :rules="ruleRequired"
                            v-model="editedItem.curso" label="Selecione o curso" return-object>
                        </v-combobox>
                    </v-col>

                    <v-col v-if="filtroPorTurma" cols="12" md="2">
                        <v-select v-model="editedItem.classe" :rules="ruleRequired" item-value="idClasse"
                            item-text="descricao" @change="onClasseChange" :items="classes" label="Selecione a Classe"
                            return-object :item-disabled="item => !item.show">
                        </v-select>
                    </v-col>

                    <v-col v-if="filtroPorTurma" cols="12" md="3">
                        <v-select id="turma" v-model="editedItem.turma" :rules="ruleRequired" item-value="idTurma"
                            item-text="turmadescricao" @change="onTurmaChange" :items="turmasFiltered" label="*Turma"
                            return-object>
                        </v-select>
                    </v-col>

                    <v-col cols="12" md="2">
                        <v-btn color="primary" @click="aplicarFiltros"
                            :disabled="!anolectivoSelected || !tipoNotaSelected" :loading="loading">
                            Aplicar Filtros
                        </v-btn>
                    </v-col>
                </v-row>


            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import axios from '@/plugins/axios'
const ls = require("local-storage")

export default {
    name: 'FiltrosNotasPendentes',
    data() {
        return {
            selectedTipoNota: null,
            tiposDeNota: [
                { idTipoNota: 1, descricao: "Iº Trimestre", show: true },
                { idTipoNota: 2, descricao: "IIº Trimestre", show: true },
                { idTipoNota: 3, descricao: "IIIº Trimestre", show: true },
                { idTipoNota: 4, descricao: "Exame", show: true },
                { idTipoNota: 5, descricao: "Recurso", show: true },
                { idTipoNota: 6, descricao: "Nota Finalista", show: true }
            ],
            filtroIsNotaLancadaSelecionado: { isNotaLancada: 2, descricao: 'Todos' },
            filtroIsNotaLancada: [
                { isNotaLancada: 0, descricao: 'Professores sem notas lançadas' },
                { isNotaLancada: 1, descricao: 'Professores com notas lançadas' },
                { isNotaLancada: 2, descricao: 'Todos' },
            ],
            tipoNotaSelected: null,
            anolectivoSelected: null,
            anolectivoSelected: ls.get('anolectivo'),
            anolectivoActual: ls.get('anolectivo'),
            isLoading: false,
            filtroPorTurma: false,
            editedItem: {
                curso: null,
                classe: null,
                turma: null
            },
            anolectivo: {
                novadescricao: ls.get("novadescricao"),
                descricao: ls.get("anolectivo"),
            },
            idInstituicao: ls.get("i_id"),
            cursos: [],
            listarAnosLectivo: [],
            classes: null,
            turmasAll: [],
            turmasFiltered: [],
            ruleRequired: [(v) => !!v || 'Campo obrigatório']
        }
    },
    computed: {
        idclasse() {
            return this.editedItem.classe && this.editedItem.classe.id || '';
        },
        isIntegrado() {
            return 1;
        },
        ListaActividades() {
            return ls.get("lista_actividades");
        }
    },
    created() {
        this.initializeAnosLectivo()
        if (this.anolectivoSelected) {
            this.initializeCursos()
        }
    },
    watch: {
        anolectivoSelected(value) {
            this.onAnolectivoChange(value);
        },
        selectedTipoNota(value) {
            this.tipoNotaSelected = value;
        },
        filtroIsNotaLancadaSelecionado(value) {
            this.filtroIsNotaLancadaSelecionado = value;
        },
        cursoSelected(value) {
            this.onCursoChange(value);
        },
        classeSelected(value) {
            this.onClasseChange(value);
        },
        turmaSelected(value) {
            this.onTurmaChange(value);
        },
    },
    methods: {
        onFilterChange(value) {
            this.filtroPorTurma = Boolean(value === true || value === 'true');
            console.log('Filtro atualizado para por turma?', this.filtroPorTurma);
            this.$emit('filter-mode-changed', this.filtroPorTurma);
            // Reset filter selections when changing mode
            this.editedItem.curso = null;
            this.editedItem.classe = null;
            this.editedItem.turma = null;
            // Emit empty filters to clear results
            this.$emit('filters-applied', {
                anoLectivo: this.anolectivoSelected,
                isNotaLancada: this.filtroIsNotaLancadaSelecionado.isNotaLancada,
                curso: null,
                classe: null,
                tipoNota: this.tipoNotaSelected,
                turma: null
            });
        },

        onAnolectivoChange(value) {
            console.log('Ano lectivo selecionado:', value);
        },

        onTipoNotaChange(value) {
            console.log('Tipo de nota selecionado:', value);
        },

        onTurmaChange(value) {
            // Reset any dependent selections or data when turma changes
            this.$emit('turma-changed', value);
        },

        onFilterChange(value) {
            this.filtroPorTurma = Boolean(value === true || value === 'true');
            console.log('Filtro atualizado para por turma?', this.filtroPorTurma);
            this.$emit('filter-mode-changed', this.filtroPorTurma);
            // Reset filter selections when changing mode
            this.editedItem.curso = null;
            this.editedItem.classe = null;
            this.editedItem.turma = null;
            // Emit empty filters to clear results
            this.$emit('filters-applied', {
                anoLectivo: this.anolectivoSelected,
                isNotaLancada: this.filtroIsNotaLancadaSelecionado.isNotaLancada,
                curso: null,
                classe: null,
                idTipoNota: this.tipoNotaSelected.idTipoNota,
                tipoNota: this.tipoNotaSelected.descricao,
                turma: null
            });
        },

        aplicarFiltros() {
            if (!this.anolectivoSelected) {
                this.showMessageSnackbar('Por favor, selecione um ano letivo.', 'error');
                return;
            }

            if (this.filtroPorTurma) {
                if (!this.editedItem.curso || !this.editedItem.curso.idCurso) {
                    this.showMessageSnackbar('Por favor, selecione um curso.', 'error');
                    return;
                }

                if (!this.editedItem.classe || !this.editedItem.classe.idClasse) {
                    this.showMessageSnackbar('Por favor, selecione uma classe.', 'error');
                    return;
                }

                if (!this.editedItem.turma || !this.editedItem.turma.pkTurma) {
                    this.showMessageSnackbar('Por favor, selecione uma turma.', 'error');
                    return;
                }

                const filtros = {
                    anoLectivo: this.anolectivoSelected,
                    isNotaLancada: this.filtroIsNotaLancadaSelecionado.isNotaLancada,
                    curso: this.editedItem.curso.idCurso,
                    classe: this.editedItem.classe.idClasse,
                    idTipoNota: this.tipoNotaSelected ? this.tipoNotaSelected.idTipoNota : '',
                    tipoNota: this.tipoNotaSelected ? this.tipoNotaSelected.descricao : '',
                    turma: this.editedItem.turma.pkTurma
                };

                this.$emit('filters-applied', filtros);
            } else {
                const filtros = {
                    anoLectivo: this.anolectivoSelected,
                    isNotaLancada: this.filtroIsNotaLancadaSelecionado.isNotaLancada,
                    idTipoNota: this.tipoNotaSelected ? this.tipoNotaSelected.idTipoNota : '',
                    tipoNota: this.tipoNotaSelected ? this.tipoNotaSelected.descricao : '',
                };

                this.$emit('filters-applied', filtros);
            }
        },

        initializeAnosLectivo() {
            try {
                this.listarAnosLectivo = axios
                    .get('/listarAnoLectivoAll')
                    .then(res => res.data)
            } catch (error) {
                this.$store.dispatch('textMessage', { 'msg': error, 'classMessage': 'msgError', 'timeout': 3000 })
            }
        },

        aplicarFiltros() {
            if (!this.anolectivoSelected) {
                this.showMessageSnackbar('Por favor, selecione um ano letivo.', 'error');
                return;
            }

            if (this.filtroPorTurma) {
                if (!this.editedItem.curso || !this.editedItem.curso.idCurso) {
                    this.showMessageSnackbar('Por favor, selecione um curso.', 'error');
                    return;
                }

                if (!this.editedItem.classe || !this.editedItem.classe.idClasse) {
                    this.showMessageSnackbar('Por favor, selecione uma classe.', 'error');
                    return;
                }

                if (!this.editedItem.turma || !this.editedItem.turma.pkTurma) {
                    this.showMessageSnackbar('Por favor, selecione uma turma.', 'error');
                    return;
                }

                const filtros = {
                    anoLectivo: this.anolectivoSelected,
                    curso: this.editedItem.curso.idCurso,
                    classe: this.editedItem.classe.idClasse,
                    turma: this.editedItem.turma.pkTurma,
                    isNotaLancada: this.filtroIsNotaLancadaSelecionado.isNotaLancada,
                    idTipoNota: this.tipoNotaSelected ? this.tipoNotaSelected.idTipoNota : '',
                    tipoNota: this.tipoNotaSelected ? this.tipoNotaSelected.descricao : '',
                };

                this.$emit('filters-applied', filtros);
            } else {
                if (!this.tipoNotaSelected) {
                    this.showMessageSnackbar('Por favor, selecione um tipo de nota.', 'error');
                    return;
                }
                const filtros = {
                    anoLectivo: this.anolectivoSelected,
                    isNotaLancada: this.filtroIsNotaLancadaSelecionado.isNotaLancada,
                    idTipoNota: this.tipoNotaSelected ? this.tipoNotaSelected.idTipoNota : '',
                    tipoNota: this.tipoNotaSelected ? this.tipoNotaSelected.descricao : '',
                };

                this.$emit('filters-applied', filtros);
            }
        },

        async initializeAnosLectivo() {
            try {
                this.listarAnosLectivo = await axios
                    .get('/listarAnoLectivoAll')
                    .then(res => res.data)
            } catch (error) {
                this.text = error
                this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
            } finally {
            }
        },

        async initializeCursos() {
            this.isLoading = true;
            try {
                this.cursos = await axios.get("/cursoFindAll").then((res) => res.data);
            } catch (error) {
                this.showMessageSnackbar(`Ocorreu um erro: ${error}`, "red");
            } finally {
                this.isLoading = false;
            }
        },

        onCursoChange(value) {
            this.editedItem.turma = { idTurma: "", pkTurma: 0 };
            this.editedItem.classe = { idClasse: "", pkClasse: 0 };
            this.turmasFiltered = [];
            this.loadClasseComb();
        },

        onClasseChange(value) {
            this.editedItem.turma = null;
            this.turmasFiltered = [];
            this.filtrarTurmas();
        },

        loadClasseComb() {
            if (this.editedItem.curso && this.editedItem.curso.idCurso) {
                this.classes = [
                    { descricao: "10ª Classe", idClasse: 1, show: true },
                    { descricao: "11ª Classe", idClasse: 2, show: true },
                    { descricao: "12ª Classe", idClasse: 3, show: true },
                    { descricao: "13ª Classe", idClasse: 4, show: true }
                ];
            } else {
                this.classes = [];
                this.editedItem.classe = null;
                this.editedItem.turma = null;
            }
        },

        async filtrarTurmas() {
            if (!this.editedItem.curso || !this.editedItem.classe) {
                return;
            }

            this.isLoading = true;
            try {
                const response = await axios.get(`/turmaFindAll/${this.editedItem.classe.idClasse}`);

                this.turmasFiltered = response.data.filter((t) => t.idCurso == this.editedItem.curso.idCurso)

                this.$nextTick(() => {
                    this.editedItem.turma = { idTurma: "", pkTurma: 0 };
                });

            } catch (error) {
                this.showMessageSnackbar(`Erro ao carregar turmas: ${error.message}`, "error");
            } finally {
                this.isLoading = false;
            }
        },

        showMessageSnackbar(message, color = "success") {
            this.$emit('showSnackbar', { message, color })
        },
    },
}

</script>

<style scoped>
.card {
    z-index: 1;
    margin-bottom: 2rem;
    border: 1px solid #e3e6f0;
    border-radius: 0.35rem;
    box-shadow: 0 0.15rem 1.75rem 0 rgba(58, 59, 69, 0.15);
}

.card-header {
    background-color: #f8f9fc;
    border-bottom: 1px solid #e3e6f0;
    padding: 1rem;
}

.card-header h4 {
    color: #3d3d3d;
    font-weight: 600;
}

.card-body {
    padding: 1rem;
}

.form-group {
    margin-bottom: 1rem;
}

.form-label {
    display: block;
    margin-bottom: 0.5rem;
    font-weight: 500;
    color: #5a5c69;
}

.form-select {
    display: block;
    width: 100%;
    padding: 0.75rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    color: #6e707e;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #d1d3e2;
    border-radius: 0.35rem;
    transition: border-color 0.15s ease-in-out;
}

.form-select:focus {
    color: #6e707e;
    background-color: #fff;
    border-color: #858796;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}

.table {
    margin-bottom: 0;
}

.table-responsive {
    overflow-x: auto;
}

.btn-sm {
    padding: 0.375rem 0.75rem;
    font-size: 0.875rem;
    line-height: 1.5;
    border-radius: 0.35rem;
}

.page-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 1rem;
    background-color: #f8f9fc;
    overflow: hidden;
}

.uppercase {
    text-transform: uppercase;
}
</style>